module.exports = __webpack_public_path__ + "kudos_49.svg?41f27b64eeca7aa6016a71e667ccdad0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_49.svg
// module id = 149
// module chunks = 0